"use client";

import { useI18n } from "@/providers/i18n";

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-2">
      <h1 className="text-2xl font-semibold">{t('Page Not Found')}</h1>
      <p className="text-muted-foreground">{t("The page you are looking for doesn’t exist or has been removed.")}</p>
      <a
        href="/"
        className="mt-4 inline-flex items-center rounded-md border px-3 py-2 text-sm hover:bg-accent"
      >
        {t('Go to Home')}
      </a>
    </div>
  );
}
